/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  empty,
  errorResponse,
  isArray,
  isObject,
  isString,
  prepareResponseData,
  reIndex,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";
import * as Yup from "yup";
import { Form, Formik } from "formik";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "./Staff.css";

// api
import staffApi from "../../api/Staff";
import subjectApi from "../../api/Subject";
import classApi from "../../api/Classes";
import generalApi from "../../api/General";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import Card from "../../components/card/Card";
import StatCard from "../../components/statcard/StatCard";
import {
  FaBookReader,
  FaChartArea,
  FaChartLine,
  FaCheck,
  FaClock,
  FaCloudUploadAlt,
  FaImage,
  FaQrcode,
  FaRegPlusSquare,
  FaStar,
  FaTimes,
  FaUserEdit,
  FaUserGraduate,
} from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import { Avatar } from "primereact/avatar";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import ItemLoading from "../../components/skeleton/ItemLoading";
import BoxLoading from "../../components/skeleton/BoxLoading";
import TableLoading from "../../components/skeleton/TableLoading";
import FullPageLoader from "../../components/loader/FullPageLoader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import colors from "../../config/colors";
import Underline from "../../components/others/Underline";
import SelectField from "../../components/form/SelectField";
import MultiSelectField from "../../components/form/MultiSelectField";
import { classGroup } from "../../data/ClassGroup";
import CopyTextButton from "../../components/buttons/floatingButton/CopyTextButton";

const validationSchema = Yup.object().shape({
  // attendance_assign_by: Yup.string().optional(),
  result_assign_by: Yup.string().optional(),
  result_assign_classes: Yup.array().optional(),
  result_assign_categories: Yup.array().optional(),
});

const StaffProfile = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [staffData, setStaffData] = useState({});
  const [numberOfClasses, setNumberOfClasses] = useState(0);
  const [numOfSubjects, setNumOfSubjects] = useState(0);
  const [isSubjectModal, setIsSubjectModal] = useState(false);
  const [selectedClassDetails, setSelectedClassDetails] = useState({});
  const [assignedClasses, setAssignedClasses] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [authorizedSubjects, setAuthorizedSubjects] = useState([]);
  const [assessmentPercentage, setAssessmentPercentage] = useState(0);
  const [reIndexedSubjects, setReIndexedSubjects] = useState({});
  const [modalType, setModalType] = useState("");
  const [reIndexedClasses, setReIndexedClasses] = useState({});
  const [isUploadAvatarModal, setIsUploadAvatarModal] = useState(false);
  const [resultInputType, setResultInputType] = useState("");
  const [attendanceInputType, setAttendanceInputType] = useState("");
  const [previewAvatar, setPreviewAvatar] = useState("");
  const [classCategories, setClassCategories] = useState([]);
  const [classes, setClasses] = useState([]);
  const [qrCodePath, setQRcodePath] = useState("");
  const [initials, setInitials] = useState("");
  const [avatar, setAvatar] = useState(
    !empty(staffData) && !empty(staffData.avatar) ? staffData.avatar : ""
  );
  const fileInputRef = useRef(null);
  const location = useLocation();
  const [initialValues, setInitialValues] = useState({
    // attendance_assign_by: "",
    result_assign_by: "",
    result_assign_categories: [],
    result_assign_classes: [],
  });

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // (WIP)
  const { staffId } = useParams();
  const toastTR = useRef(null);

  if (!staffId) {
    navigate("/404");
  }

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    // check if a new staff was added or updated
    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      const staffAdded = !empty(paramState.staffAdded)
        ? paramState.staffAdded
        : false;
      const staffUpdated = !empty(paramState.staffUpdated)
        ? paramState.staffUpdated
        : false;
      if (staffAdded === true || staffUpdated === true) {
        const actionType = staffAdded ? "added" : "updated";
        paramState.staffAdded = false;
        paramState.staffUpdated = false;
        responseDialog(
          "success",
          "Success",
          `Staff ${actionType} successfully!`
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: { staffAdded: false, staffUpdated: false },
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    getStaffDetails();
    getSubjects();
    getClasses();
    getClassCategories();
  }, [staffId]);

  const getStaffDetails = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await staffApi.getStaffProfile(staffId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }
      const staffDetails =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {};
      const classes =
        !empty(response_data) && !empty(staffDetails.assignedClasses)
          ? staffDetails.assignedClasses
          : [];
      const _authorizedSubjects =
        !empty(staffDetails) && !empty(staffDetails.authorizedSubjects)
          ? staffDetails.authorizedSubjects
          : [];
      setAvatar(
        !empty(staffDetails) && !empty(staffDetails.avatar)
          ? staffDetails.avatar
          : ""
      );
      const authorizations =
        !empty(response_data) &&
        !empty(staffDetails.authorizations) &&
        isObject(staffDetails.authorizations)
          ? staffDetails.authorizations
          : [];
      const resultChecker =
        !empty(authorizations) &&
        !empty(authorizations.result_checker) &&
        isObject(authorizations.result_checker)
          ? authorizations.result_checker
          : {};
      const resultAssignBy =
        !empty(resultChecker) &&
        !empty(resultChecker.resultAssignBy) &&
        isString(resultChecker.resultAssignBy)
          ? resultChecker.resultAssignBy
          : "";
      const resultAssignCategories =
        !empty(resultChecker) &&
        !empty(resultChecker.resultAssignCategories) &&
        isArray(resultChecker.resultAssignCategories)
          ? resultChecker.resultAssignCategories
          : [];
      const resultAssignClasses =
        !empty(resultChecker) &&
        !empty(resultChecker.resultAssignClasses) &&
        isArray(resultChecker.resultAssignClasses)
          ? resultChecker.resultAssignClasses
          : [];
      setInitialValues({
        result_assign_by: resultAssignBy,
        result_assign_categories: resultAssignCategories,
        result_assign_classes: resultAssignClasses,
      });
      setResultInputType(
        !empty(resultAssignCategories) && !empty(resultAssignClasses)
          ? "All"
          : resultAssignBy
      );

      const subjectIds = [];
      for (let i = 0; i < _authorizedSubjects.length; i++) {
        const ids =
          !empty(_authorizedSubjects[i]) &&
          !empty(_authorizedSubjects[i].subjectIds)
            ? _authorizedSubjects[i].subjectIds
            : "";
        subjectIds.push(...ids);
      }
      const subjectIdSet = new Set(subjectIds);

      setAuthorizedSubjects(_authorizedSubjects);
      setAssignedClasses(classes);
      setNumberOfClasses(classes.length);
      setNumOfSubjects(subjectIdSet.size);

      if (!empty(staffDetails) && isObject(staffDetails)) {
        setStaffData({
          firstName: !empty(staffDetails.firstName)
            ? staffDetails.firstName
            : "",
          _id: !empty(staffDetails._id) ? staffDetails._id : "",
          lastName: !empty(staffDetails.lastName) ? staffDetails.lastName : "",
          middleName: !empty(staffDetails.middleName)
            ? staffDetails.middleName
            : "",
          gender: !empty(staffDetails.gender) ? staffDetails.gender : "",
          title:
            !empty(staffDetails) && !empty(staffDetails.title)
              ? staffDetails.title
              : "",
          fullName: !empty(staffDetails.fullName) ? staffDetails.fullName : "",
          address: !empty(staffDetails.address) ? staffDetails.address : "",
          stateOfResidence: !empty(staffDetails.stateOfResidence)
            ? staffDetails.stateOfResidence
            : "",
          lgaOfResidence: !empty(staffDetails.lgaOfResidence)
            ? staffDetails.lgaOfResidence
            : "",
          stateOfOrigin: !empty(staffDetails.stateOfOrigin)
            ? staffDetails.stateOfOrigin
            : "",
          lgaOfOrigin: !empty(staffDetails.lgaOfOrigin)
            ? staffDetails.lgaOfOrigin
            : "",
          nationality: !empty(staffDetails.nationality)
            ? staffDetails.nationality
            : "",
          regNo: !empty(staffDetails.regNo)
            ? staffDetails.regNo
            : "",
          religion: !empty(staffDetails.religion) ? staffDetails.religion : "",
          dateOfBirth: !empty(staffDetails.dateOfBirth)
            ? staffDetails.dateOfBirth
            : "",
          phoneNumber1: !empty(staffDetails.phoneNumber1)
            ? staffDetails.phoneNumber1
            : "",
          phoneNumber2: !empty(staffDetails.phoneNumber2)
            ? staffDetails.phoneNumber2
            : "",
          email:
            !empty(staffDetails) && !empty(staffDetails.email)
              ? staffDetails.email
              : "",
          qualification: !empty(staffDetails.qualification)
            ? staffDetails.qualification
            : "",
          courseStudied: !empty(staffDetails.courseStudied)
            ? staffDetails.courseStudied
            : "",
        });
      }

      setQRcodePath(
        !empty(staffDetails.qrCodePath) && isString(staffDetails.qrCodePath)
          ? staffDetails.qrCodePath
          : ""
      );
      const firstNameInitial = staffDetails.firstName.charAt(0);
      const lastNameInitial = staffDetails.lastName.charAt(0);
      return setInitials(`${firstNameInitial}${lastNameInitial}`);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const getSubjects = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await subjectApi.getSubjects(schoolId);
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        setReIndexedSubjects({});
      } else {
        const results =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        const _reIndexedSubjects = !empty(results)
          ? reIndex(results, "_id")
          : {};
        setReIndexedSubjects(_reIndexedSubjects);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  const getClasses = async () => {
    try {
      const response = await classApi.getClasses('yes');
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }
      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];
      const _reIndexedClasses = !empty(data) ? reIndex(data, "_id") : {};
      setReIndexedClasses(_reIndexedClasses);
      setClasses(data);
    } catch (error) {}
  };

  const assignClassSubjectsToStaff = async () => {
    try {
      if (!actionLoading) setActionLoading(true);
      setIsSubjectModal(false);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const classId =
        !empty(selectedClassDetails) && !empty(selectedClassDetails._id)
          ? selectedClassDetails._id
          : "";
      const response = await staffApi.assignClassSubjectsToStaff(
        staffId,
        schoolId,
        classId,
        modalType
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }

      getStaffDetails();
      return responseDialog(
        "success",
        "Success",
        "Class(es) assigned successfully"
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setActionLoading(false);
    }
  };

  //function to show confirm modal
  const showSubjectModal = (data, type) => {
    setSelectedClassDetails(data);
    setModalType(type);
    setIsSubjectModal(true);
  };

  //function to hide confirm modal
  const hideSubjectModal = () => {
    setIsSubjectModal(false);
  };

  const subjectModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={hideSubjectModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={assignClassSubjectsToStaff}
      />
    </div>
  );

  // Function to trigger the hidden file input click
  const handleImageFilePickUp = () => {
    fileInputRef.current.click();
  };

  // Function to handle the selected file
  const handleFileUpload = async (event) => {
    try {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        // Convert file to Base64 when the file is loaded
        reader.onloadend = async () => {
          const base64String = reader.result;
          setPreviewAvatar(base64String);
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {}
  };

  const submitAvatar = async () => {
    // send file to the server
    try {
      if (!actionLoading) setActionLoading(true);
      const staffId =
        !empty(staffData) && !empty(staffData._id) ? staffData._id : "";
      const response = await staffApi.uploadStaffAvatar(
        staffId,
        previewAvatar,
        "staff"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) &&
            !empty(response_data.response) &&
            isString(response_data.response)
            ? response_data.response
            : "Failed to update staff avatar!"
        );
      }

      // clean data
      setPreviewAvatar("");
      setAvatar(previewAvatar);

      return responseDialog(
        "success",
        "Success",
        "Staff avatar updated successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setActionLoading(false);
      setIsUploadAvatarModal(false);
    }
  };

  const getClassCategories = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await classApi.getClassCategories(schoolId);
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        return setClassCategories([]);
      }
      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];
      setClassCategories(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (!submitLoading) setSubmitLoading(true);
      let attendance_assign_by = "";
      let result_assign_by = "";
      let result_assign_categories = [];
      let result_assign_classes = [];
      if (!empty(values) && isObject(values)) {
        attendance_assign_by =
          !empty(values.attendance_assign_by) &&
          isString(values.attendance_assign_by)
            ? values.attendance_assign_by
            : "";
        result_assign_by =
          !empty(values.result_assign_by) && isString(values.result_assign_by)
            ? values.result_assign_by
            : "";
        result_assign_categories =
          !empty(values.result_assign_categories) &&
          isArray(values.result_assign_categories)
            ? values.result_assign_categories
            : [];
        result_assign_classes =
          !empty(values.result_assign_classes) &&
          isArray(values.result_assign_classes)
            ? values.result_assign_classes
            : [];
        let type =
          !empty(result_assign_categories) && !empty(result_assign_classes)
            ? "All"
            : result_assign_by;
        const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
        const response = await staffApi.addAuthorizations({
          attendance_assign_by,
          result_assign_by: type,
          result_assign_classes,
          result_assign_categories,
          school_id: schoolId,
          staff_id: staffId,
        });
        const response_data = prepareResponseData(response);
        if (!empty(response_data) && !response_data.success) {
          return responseDialog(
            "error",
            "Error Alert",
            !empty(response_data) && !empty(response_data.response)
              ? response_data.response
              : "Something went wrong!"
          );
        }
        return responseDialog(
          "success",
          "Success",
          "Staff authorization updated successfully!"
        );
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setSubmitLoading(false);
    }
  };

  /**
   * update qrcode
   * @returns
   */
  const updateQRCode = async () => {
    // send file to the server
    try {
      if (!submitLoading) setSubmitLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const staffId =
        !empty(staffData) && !empty(staffData._id) ? staffData._id : "";
      const response = await generalApi.updateQRCode(
        staffId,
        schoolId,
        "staff"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update qr-code!"
        );
      }

      let qrCodePath = "";
      if (
        !empty(response_data) &&
        !empty(response_data.response) &&
        !empty(response_data.response.qrCodePath)
      ) {
        qrCodePath = response_data.response.qrCodePath;
      }
      // update qr code
      setQRcodePath(qrCodePath);

      return responseDialog(
        "success",
        "Success",
        "Update qr-code successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setSubmitLoading(false);
    }
  };

  // handle attendance type
  const handleInputType = (name, setFieldValue, type) => (e) => {
    const value =
      !empty(e) &&
      !empty(e.target) &&
      !empty(e.target.value) &&
      isString(e.target.value)
        ? e.target.value
        : "";
    setFieldValue(name, value);
    if (type === "result") {
      setResultInputType(value);
    }

    if (type === "attendance") {
      setAttendanceInputType(value);
    }
  };

  const handleMultiSelectChange = (name, newValue, setFieldValue) => {
    const itemIds = !empty(newValue) && isArray(newValue) ? newValue : [];
    setFieldValue(name, itemIds);
  };

  const updateProfile = () => {
    navigate(`/staff/${staffId}/update`);
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Staff Profile" />
          {/* end menu header */}

          <div className="mt-20 mb-10">
            <>
              <ButtonIcon
                borderColor={colors.primary}
                backgroundColor={colors.primary}
                color={colors.white}
                buttonText="Time Table"
                iconMarginRight={8}
                icon={<FaClock size={12} />}
                width={150}
                height={30}
                onClick={() =>
                  navigate(`/time-table/home`, {
                    replace: true,
                    state: { staffId },
                  })
                }
              />
            </>
          </div>
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div id="main_left_box">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Classes"
                        entry={numberOfClasses}
                        icon={
                          <FaUserGraduate
                            size={12}
                            className="stat_card_icon"
                          />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Subjects"
                        entry={numOfSubjects}
                        icon={
                          <FaBookReader size={12} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Assessment"
                      entry={assessmentPercentage + "%"}
                      icon={
                        <FaChartLine size={12} className="stat_card_icon" />
                      }
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Attendance"
                      entry="N/A"
                      icon={
                        <FaChartArea size={12} className="stat_card_icon" />
                      }
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

              {/* chart */}
              <div className="chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Staff Bio-Data" />
                      <div className="dashboard_school_list">
                        <div className="avatar-container flex">
                          <div className="staff-avatar-container">
                            <p className="fs-20 bold">
                              {staffData.title} {staffData.fullName}
                            </p>
                            <div className="w-100pc direction-column">
                              {!empty(avatar) ? (
                                <Avatar
                                  image={avatar}
                                  shape="circle"
                                  style={{
                                    width: 200,
                                    height: 200,
                                    padding: 10,
                                    marginLeft: 15,
                                  }}
                                  className="mb-10"
                                ></Avatar>
                              ) : (
                                <Avatar
                                  label={initials}
                                  shape="circle"
                                  style={{
                                    width: 150,
                                    height: 150,
                                    fontSize: 70,
                                    marginLeft: 15,
                                  }}
                                  className="mb-10"
                                ></Avatar>
                              )}
                              <div>
                                <ButtonIcon
                                  height={50}
                                  color={colors.primary}
                                  backgroundColor="transparent"
                                  width={180}
                                  fontSize={14}
                                  borderColor="transparent"
                                  buttonText="Update Avatar"
                                  iconMarginRight={8}
                                  icon={<FaCloudUploadAlt />}
                                  fontWeight="bold"
                                  onClick={() => setIsUploadAvatarModal(true)}
                                />

                                <ButtonIcon
                                  height={50}
                                  color={colors.primary}
                                  backgroundColor="transparent"
                                  width={180}
                                  marginTop={-2}
                                  fontSize={14}
                                  borderColor="transparent"
                                  buttonText="Update Profile"
                                  iconMarginRight={8}
                                  icon={<FaUserEdit />}
                                  fontWeight="bold"
                                  onClick={() => updateProfile()}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">First Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.firstName
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Last Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.lastName
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Middle Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.middleName
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Gender: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.gender
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Title: </div>
                              <div className="profile-value">
                                {!isLoading ? staffData.title : <ItemLoading />}
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">Address: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.address
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.stateOfResidence
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.lgaOfResidence
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.stateOfOrigin
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Origin:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.lgaOfOrigin
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="other-staff-info-header mb-20">
                          <MainHeader title="Other Information" />
                        </div>
                        <div className="flex sm-reverse-direction-vertical other-staff-info col-g-12 mb-20">
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">Nationality: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.nationality
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Religion</div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.religion
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Date of Birth</div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.dateOfBirth
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Phone Number 1
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.phoneNumber1
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Phone Number 2
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.phoneNumber2
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Email: </div>
                              <div className="profile-value">
                                {!isLoading ? staffData.email : <ItemLoading />}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Qualification</div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.qualification
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Course Studied
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  staffData.courseStudied
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block">
                            <img
                              width={250}
                              height={250}
                              src={qrCodePath}
                              alt="qrcode"
                            />
                            <ButtonIcon
                              height={40}
                              marginTop={1}
                              color={colors.primary}
                              backgroundColor={colors.lightgray}
                              width={180}
                              fontSize={14}
                              borderColor={colors.lightgray}
                              buttonText="Update QR-Code"
                              iconMarginRight={8}
                              marginLeft={4}
                              icon={<FaQrcode />}
                              fontWeight="bold"
                              onClick={() => updateQRCode()}
                            />
                          </div>
                        </div>
                        <Underline width="100%" height={2} />
                        <div className="mt-20">
                          <MainHeader title="Authorizations" />
                        </div>
                        <div className="form-container">
                          <Formik
                            enableReinitialize
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                          >
                            {({ values, handleChange, setFieldValue }) => (
                              <Form style={{ width: "100%" }}>
                                <div>
                                  <em>
                                    Please select the required authorization for
                                    this staff. This can be updated anytime.
                                  </em>
                                </div>
                                <div className="form-section-title">
                                  Check Result
                                  <Underline />
                                </div>
                                <div className="app_input_group">
                                  <SelectField
                                    labelTitle="Assign by"
                                    required={true}
                                    placeholder="Select type"
                                    name="result_assign_by"
                                    options={classGroup}
                                    height={45}
                                    valueKey="title"
                                    selectedOption={values.result_assign_by}
                                    handleChangeFunc={handleInputType(
                                      "result_assign_by",
                                      setFieldValue,
                                      "result"
                                    )}
                                  />
                                </div>
                                <div className="app_input_group">
                                  {(resultInputType === "Category" ||
                                    resultInputType === "All") && (
                                    <MultiSelectField
                                      name="result_assign_categories"
                                      labelTitle="Select Class Category(ies)"
                                      placeholder="Select Class Category(ies)"
                                      options={classCategories}
                                      valueKey="_id"
                                      mt="mt-0"
                                      selectedOptions={
                                        values.result_assign_categories
                                      }
                                      onChange={(e) =>
                                        handleMultiSelectChange(
                                          "result_assign_categories",
                                          e.value,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  )}
                                </div>
                                <div className="app_input_group mb-20">
                                  {(resultInputType === "Class" ||
                                    resultInputType === "All") && (
                                    <MultiSelectField
                                      labelTitle="Classes"
                                      placeholder="Select Class(es)"
                                      name="result_assign_classes"
                                      options={classes}
                                      selectedOptions={
                                        values.result_assign_classes
                                      }
                                      valueKey="_id"
                                      mt="mt-0"
                                      onChange={(e) =>
                                        handleMultiSelectChange(
                                          "result_assign_classes",
                                          e.value,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  )}
                                </div>
                                <Underline width="100%" height={2} />
                                {/* <div className="form-section-title">
                                  Attendance
                                  <Underline />
                                </div>
                                <div className="app_input_group">
                                  <SelectField
                                    labelTitle="Assign by"
                                    required={true}
                                    placeholder="Select type"
                                    name="attendance_assign_by"
                                    options={classType}
                                    height={45}
                                    valueKey="title"
                                    selectedOption={values.attendance_assign_by}
                                    handleChangeFunc={handleInputType(
                                      "attendance_assign_by",
                                      setFieldValue,
                                      "attendance"
                                    )}
                                  />
                                  {attendanceInputType === "Category" && (
                                    <MultiSelectField
                                      name="attendance_assign_categories"
                                      required={true}
                                      labelTitle="Select Class Category(ies)"
                                      placeholder="Select Class Category(ies)"
                                      options={classCategories}
                                      valueKey="title"
                                      mt="mt-10"
                                      selectedOptions={
                                        values.attendance_assign_categories
                                      }
                                      onChange={handleChange}
                                    />
                                  )}
                                  {attendanceInputType === "Class" && (
                                    <MultiSelectField
                                      labelTitle="Classes"
                                      required={true}
                                      placeholder="Select Class(es)"
                                      name="attendance_assign_classes"
                                      options={classes}
                                      mt="mt-10"
                                      selectedOptions={
                                        values.attendance_assign_classes
                                      }
                                      valueKey="title"
                                      onChange={handleChange}
                                    />
                                  )}
                                </div> */}
                                <div className="form-button-container">
                                  <ButtonIcon
                                    height={45}
                                    marginTop={5}
                                    color={colors.white}
                                    backgroundColor={colors.primary}
                                    width={300}
                                    borderColor={colors.primary}
                                    buttonText="Update Staff Authorizations"
                                    type="submit"
                                  />
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </>
                  }
                  addStyle="student_list_box"
                />
              </div>
              {/* end chart */}

              {/*  */}
            </div>
            {/* end of left box */}

            {/* right box */}
            <div id="main_right_box">
              <div className="main_right_boxes">
                <Card
                  children={
                    <>
                      <MainHeader
                        title="Assigned Class(es)"
                        rightIcon={
                          <NavLink to={`/staff/${staffId}/class/assign`}>
                            <FaRegPlusSquare
                              style={{
                                color: colors.success,
                                cursor: "pointer",
                              }}
                            />
                          </NavLink>
                        }
                      />
                      <div className="mt-10">
                        {!isLoading ? (
                          assignedClasses.map((item) => {
                            return (
                              <p
                                key={
                                  !empty(item) && !empty(item._id)
                                    ? item._id
                                    : 0
                                }
                                className="mb-10 flex space-between bio-data-item"
                              >
                                <span>
                                  <FaStar
                                    style={{
                                      marginRight: 8,
                                      fontSize: 12,
                                    }}
                                    color={colors.orange}
                                  />
                                  {!empty(item) && !empty(item.title) ? (
                                    <NavLink
                                      style={{
                                        textDecoration: "none",
                                        color: colors.primary,
                                      }}
                                      to={`/classes/${
                                        !empty(item) && !empty(item._id)
                                          ? item._id + "/profile"
                                          : ""
                                      }`}
                                    >
                                      {item.title}
                                    </NavLink>
                                  ) : (
                                    ""
                                  )}
                                </span>
                                <span
                                  style={{
                                    cursor: "pointer",
                                    color: colors.primary,
                                  }}
                                >
                                  <NavLink>
                                    <FaCheck
                                      style={{
                                        cursor: "pointer",
                                        color: colors.success,
                                        marginRight: 8,
                                      }}
                                      onClick={() =>
                                        showSubjectModal(item, "assign")
                                      }
                                    />
                                  </NavLink>
                                  <NavLink>
                                    <FaTimes
                                      style={{
                                        cursor: "pointer",
                                        color: colors.danger,
                                      }}
                                      onClick={() =>
                                        showSubjectModal(item, "remove")
                                      }
                                    />
                                  </NavLink>
                                </span>
                              </p>
                            );
                          })
                        ) : (
                          <TableLoading rows={6} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="card_adjust"
                />
                <Card
                  children={
                    <>
                      <MainHeader
                        title="Assigned Subjects"
                        rightIcon={
                          <NavLink to={`/staff/${staffId}/subjects/assign`}>
                            <FaRegPlusSquare
                              style={{
                                color: colors.primary,
                                cursor: "pointer",
                              }}
                            />
                          </NavLink>
                        }
                      />
                      <div className="mt-10">
                        {!isLoading ? (
                          authorizedSubjects.map((data) => {
                            const _classId =
                              !empty(data) && !empty(data.classId)
                                ? data.classId
                                : "";
                            const _subjectIds =
                              !empty(data) && !empty(data.subjectIds)
                                ? data.subjectIds
                                : [];
                            const _classTitle =
                              reIndexedClasses?.[_classId]?.title || "";

                            const subjects = _subjectIds.map((item) => {
                              const title =
                                !empty(reIndexedSubjects) &&
                                !empty(reIndexedSubjects[item]) &&
                                !empty(reIndexedSubjects[item].title)
                                  ? reIndexedSubjects[item].title
                                  : "";
                              return title;
                            });

                            return (
                              <div
                                key={_classId}
                                className="mb-10 flex direction-column bio-data-item"
                              >
                                <span
                                  style={{
                                    color: colors.primary,
                                  }}
                                >
                                  <FaStar
                                    style={{
                                      marginRight: 8,
                                      fontSize: 12,
                                    }}
                                    color={colors.orange}
                                  />
                                  {_classTitle}:
                                </span>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    marginTop: 5,
                                    fontSize: 14,
                                  }}
                                >
                                  <ul className="ml-15">
                                    {subjects.map((data, index) => (
                                      <li className="mb-5" key={index}>
                                        {data}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <TableLoading rows={6} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="card_adjust"
                />
              </div>
            </div>
            {/* end of right box */}
          </div>
        </main>
        {submitLoading && <FullPageLoader visible={submitLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
        <CopyTextButton
          width={65}
          height={65}
          right={35}
          actionTitle="Copy staff Id"
          successMessage="Copied staff Id"
          copyText={staffData?.regNo || ''}
        />
      </AppWrapper>

      <Dialog
        visible={isSubjectModal}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={subjectModalFooter}
        onHide={hideSubjectModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: colors.danger }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "assign" ? (
                <span style={{ color: colors.success }}>{modalType}</span>
              ) : (
                <span style={{ color: colors.danger }}>{modalType}</span>
              )}{" "}
              the subjects in{" "}
              <strong>
                {!empty(selectedClassDetails) &&
                !empty(selectedClassDetails.title)
                  ? selectedClassDetails.title
                  : "NA"}
              </strong>{" "}
              {modalType === "assign" ? "to " : "from "} staff,{" "}
              {selectedClassDetails && (
                <b>
                  {staffData.lastName} {staffData.firstName}{" "}
                  {staffData.middleName}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>

      <Dialog
        visible={isUploadAvatarModal}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Action"
        modal
        onHide={() => {
          setPreviewAvatar("");
          setIsUploadAvatarModal(false);
        }}
      >
        <div
          className="confirmation-content"
          style={{
            marginTop: 20,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="avatar-preview-box mb-20">
            {!empty(previewAvatar) ? (
              <img src={previewAvatar} alt="" />
            ) : (
              <FaCloudUploadAlt size={80} />
            )}
          </div>
          {<span>Select image to upload</span>}

          <div className="flex flex-center w-100pc col-g-12">
            <ButtonIcon
              height={40}
              marginTop={1}
              color={colors.tomato}
              backgroundColor={colors.lightgray}
              width={170}
              fontSize={22}
              borderColor={colors.lightgray}
              buttonText="Select Avatar"
              iconMarginRight={8}
              icon={<FaImage />}
              fontWeight="bold"
              onClick={handleImageFilePickUp}
            />
            {previewAvatar ? (
              <ButtonIcon
                height={40}
                marginTop={1}
                color={colors.primary}
                backgroundColor={colors.lightgray}
                width={180}
                fontSize={14}
                borderColor={colors.lightgray}
                buttonText="Update Avatar"
                iconMarginRight={8}
                icon={<FaCloudUploadAlt />}
                fontWeight="bold"
                onClick={() => submitAvatar()}
              />
            ) : null}
            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileUpload}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default StaffProfile;
